export default function configureZeroClipboard(app: any) {
  app.config([
    'ngClipProvider',
    function (ngClipProvider: any) {
      ngClipProvider.setPath('zeroclipboard/dist/ZeroClipboard.swf');
    }
  ]);
}
